/**
 * om-sort.js
 * ---------------------------------------------------------------------------
 * Enforces one global product sequence across every product grid on the site.
 *
 * Why this is done in the theme rather than in Shopify: the store's main
 * collections (Sweets, Namkeen & Snacks, ATM Series, Classic Series...) are
 * AUTOMATED collections - products join them by tag. Shopify only offers a
 * manual drag-order on manual collections, so there is no admin-side way to
 * pin a custom sequence without giving up that automation. Ordering here keeps
 * the collections automatic and still guarantees the sequence everywhere:
 * collection pages, the homepage grids, and search results.
 *
 * To change the order, edit ORDER below. Anything not listed sorts to the end,
 * keeping whatever order Shopify returned.
 *
 * Respects the shopper's own choice: if they pick a sort (price, A-Z, etc.)
 * from the collection filters, this stands down.
 *
 * Note the two grid shapes on this theme: the homepage Product Grid puts
 * .om-card straight into .om-grid, while the collection page wraps each card
 * in an <li>. So we sort whatever direct child CONTAINS a product link, not
 * the cards themselves.
 */
(function () {
  'use strict';

  if (window.__omSortBound) return;
  window.__omSortBound = true;

  var ORDER = [
    // ---- Sweets, in the house sequence. ATM first, then Classic. ----
    'atm-rasgulla',
    'classic-rasgulla',
    'atm-gulab-jamun',
    'classic-gulab-jamun',
    'classic-mini-gulab-jamun',
    'classic-panthua-gulab-jamun',
    'atm-rajbhog',
    'classic-rajbhog',
    'atm-bati',
    'classic-kesar-batti',
    'atm-cham-cham',
    'classic-cham-cham',
    'atm-rasbhari',
    'classic-rasbhari',
    'angoori-petha-1',

    // ---- Soan papdi ----
    'soan-papdi-elaichi',
    'soan-papdi-desi-ghee',
    'soan-papdi-pineapple',
    'soan-papdi-orange-1',
    'soan-papdi-chocolate',
    'soan-papdi-coconut-1',

    // ---- Ladoo ----
    'besan-ladoo-1',
    'premium-dry-fruit-besan-ladoo-desi-ghee',

    // ---- Namkeen, in the house sequence ----
    'bikaneri-bhujia-1',
    'all-in-one-2',
    'chatpat-2',
    'aloo-bhujia-1',
    'moong-dal',
    'salted-peanuts',
    'nut-cracker-1',
    'punjabi-tadka',

    // ---- Papad & paneer ----
    'panchsheel-papad-2',
    'nutkhat-papad-1',
    'paneer-cubes'
  ];

  var RANK = {};
  for (var i = 0; i < ORDER.length; i++) RANK[ORDER[i]] = i;
  var TAIL = ORDER.length + 1000;

  function shopperSorted() {
    var q = window.location.search;
    if (q.indexOf('sort_by=') === -1) return false;
    return q.indexOf('sort_by=manual') === -1;
  }

  function handleIn(el) {
    var link = el.matches && el.matches('a[href*="/products/"]')
      ? el
      : el.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function sortGrid(grid) {
    if (grid.getAttribute('data-om-sorted') === '1') return;

    var kids = grid.children;
    var rows = [];
    for (var i = 0; i < kids.length; i++) {
      var h = handleIn(kids[i]);
      if (h === null) continue;
      rows.push({
        el: kids[i],
        handle: h,
        rank: RANK.hasOwnProperty(h) ? RANK[h] : TAIL,
        idx: i
      });
    }
    if (rows.length < 2) return;

    grid.setAttribute('data-om-sorted', '1');

    var already = true;
    for (var j = 1; j < rows.length; j++) {
      if (rows[j].rank < rows[j - 1].rank) { already = false; break; }
    }
    if (already) return;

    // Remember the slots the sortable items occupied, so anything else in the
    // grid (banners, pagination) keeps its place.
    var marks = rows.map(function (r) {
      var m = document.createComment('om-slot');
      grid.insertBefore(m, r.el);
      grid.removeChild(r.el);
      return m;
    });

    rows.sort(function (a, b) {
      if (a.rank !== b.rank) return a.rank - b.rank;
      return a.idx - b.idx;
    });

    for (var k = 0; k < marks.length; k++) {
      grid.insertBefore(rows[k].el, marks[k]);
      grid.removeChild(marks[k]);
    }
  }

  function run() {
    if (shopperSorted()) return;
    var grids = document.querySelectorAll('.om-grid');
    for (var i = 0; i < grids.length; i++) sortGrid(grids[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(run, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();